<template>
  <div class="wrapper" v-if="caption == 'Neue Dokumente'">
    <p class="title">{{ caption }} :</p>
    <div class="title_detail" v-for="(item, index) in folder" :key="index">
      <Card v-bind:title="item.folder" v-bind:value="item.total"></Card>
    </div>
  </div>

  <div class="wrapper" v-else>
    <p class="title">{{ caption }}:</p>
    <div class="title_detail" v-for="(item, index) in barcode" :key="index">
      <Card v-bind:title="item.name" v-bind:value="item.barcodeCount"></Card>
    </div>
  </div>
</template>

<script>
import Card from "./Card";
export default {
  name: "CardWrapper",

  props: {
    caption: {
      type: String,
      required: true,
    },
    folder: Array,
    barcode: Array,
  },

  components: {
    Card,
  },
};
</script>

<style lang=scss>
.title_detail {
  display: -webkit-inline-box;
}
</style>